import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["expandableSection", "toggleButton", "icon", "content"]

  connect() {
    // Measure the natural height of the content
    this.measureContentHeight()
    
    // Check if there are any active filters to show expanded state initially
    const form = this.element.querySelector('form')
    const formData = new FormData(form)

    // Treat the first option in the sort dropdown as the "default" (future-proof)
    const sortSelect = form.querySelector('select[name="sort"]')
    const sortValue = formData.get('sort')
    const sortDefaultValue = sortSelect?.options?.[0]?.value
    const sortIsNonDefault = Boolean(sortValue) && Boolean(sortDefaultValue) && sortValue !== sortDefaultValue
    
    const hasFilters = formData.get('property') || 
                      formData.get('exclusive') || 
                      sortIsNonDefault
    
    if (hasFilters) {
      this.expand()
    }
  }

  measureContentHeight() {
    // Temporarily expand to measure the natural height
    const section = this.expandableSectionTarget
    const originalMaxHeight = section.style.maxHeight
    const originalOpacity = section.style.opacity
    
    // Set to auto to measure natural height
    section.style.maxHeight = 'auto'
    section.style.opacity = '1'
    
    // Get the measured height
    this.contentHeight = section.scrollHeight
    
    // Reset to original state
    section.style.maxHeight = originalMaxHeight || '0px'
    section.style.opacity = originalOpacity || '0'
  }

  toggle() {
    if (this.expandableSectionTarget.style.maxHeight !== '0px' && 
        this.expandableSectionTarget.style.maxHeight !== '') {
      this.collapse()
    } else {
      this.expand()
    }
  }

  expand() {
    // Set the dynamic height and opacity
    this.expandableSectionTarget.style.maxHeight = `${this.contentHeight}px`
    this.expandableSectionTarget.style.opacity = '1'
    
    // Change icon to chevron-up
    this.iconTarget.classList.remove('fa-sliders-h')
    this.iconTarget.classList.add('fa-chevron-up')
    
    // Change button color
    this.toggleButtonTarget.classList.add('text-blue-400')
    this.toggleButtonTarget.classList.remove('text-gray-400')
  }

  collapse() {
    // Collapse to 0 height and opacity
    this.expandableSectionTarget.style.maxHeight = '0px'
    this.expandableSectionTarget.style.opacity = '0'
    
    // Change icon back to sliders
    this.iconTarget.classList.remove('fa-chevron-up')
    this.iconTarget.classList.add('fa-sliders-h')
    
    // Reset button color
    this.toggleButtonTarget.classList.remove('text-blue-400')
    this.toggleButtonTarget.classList.add('text-gray-400')
  }
} 